/**
 * Custom Product Card Interactive Handler
 * - Connects 'เพิ่มในถุงช้อปปิ้ง' button to Shopify AJAX Cart
 * - Handles Mobile Tap-to-Activate Dual State
 */

(function() {
  function initCustomProductCards() {
    // 1. Quantity Selector (+ / -) Handler
    document.addEventListener('click', function(e) {
      const qtyBtn = e.target.closest('.js-icc-qty-btn');
      if (!qtyBtn) return;

      e.preventDefault();
      e.stopPropagation();

      const step = parseInt(qtyBtn.getAttribute('data-step') || '1', 10);
      const wrapper = qtyBtn.closest('.icc-quantity-wrapper');
      if (!wrapper) return;

      const input = wrapper.querySelector('.js-icc-qty-input');
      if (!input) return;

      let currentVal = parseInt(input.value || '1', 10);
      if (isNaN(currentVal)) currentVal = 1;
      const minVal = parseInt(input.getAttribute('min') || '1', 10);
      let maxVal = parseInt(input.getAttribute('max') || '9999', 10);
      if (isNaN(maxVal) || maxVal < minVal) maxVal = 9999;

      let newVal = currentVal + step;
      if (newVal < minVal) newVal = minVal;
      if (newVal > maxVal) newVal = maxVal;

      input.value = newVal;
      input.setAttribute('value', newVal);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // 2. AJAX Add to Bag Handler
    document.addEventListener('click', function(e) {
      const atcBtn = e.target.closest('.js-icc-atc-btn');
      if (!atcBtn) return;

      e.preventDefault();
      e.stopPropagation();

      const variantId = atcBtn.getAttribute('data-variant-id');
      if (!variantId || atcBtn.classList.contains('is-loading')) return;

      // Extract selected quantity from the card's quantity input
      const atcQtyContainer = atcBtn.closest('.icc-card-atc-qty') || atcBtn.closest('.icc-product-card');
      const qtyInput = atcQtyContainer ? atcQtyContainer.querySelector('.js-icc-qty-input') : null;
      let quantity = 1;
      if (qtyInput) {
        quantity = parseInt(qtyInput.value, 10);
        if (isNaN(quantity) || quantity < 1) quantity = 1;
      }

      atcBtn.classList.add('is-loading');
      atcBtn.classList.remove('is-success');
      const textContainer = atcBtn.querySelector('.icc-btn-text') || atcBtn.querySelector('span');
      const originalHtml = textContainer ? textContainer.innerHTML : atcBtn.innerHTML;
      if (textContainer) {
        textContainer.innerText = 'กำลังหยิบ...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      })
      .then(response => {
        if (!response.ok) throw new Error('Failed to add item to bag');
        return response.json();
      })
      .then(item => {
        // Dispatch theme-compatible cart events so mini-cart drawer opens automatically
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('theme:cart:update', { detail: { item: item } }));
        
        if (window.T4SThemeSP && typeof window.T4SThemeSP.updateCart === 'function') {
          window.T4SThemeSP.updateCart();
        }

        atcBtn.classList.remove('is-loading');
        atcBtn.classList.add('is-success');
        if (textContainer) {
          textContainer.innerText = 'หยิบสำเร็จ ✓';
        }

        setTimeout(() => {
          atcBtn.classList.remove('is-success');
          if (textContainer) {
            textContainer.innerHTML = originalHtml;
          }
          if (qtyInput) {
            qtyInput.value = 1;
          }
        }, 1500);
      })
      .catch(err => {
        console.error('Error adding to cart:', err);
        atcBtn.classList.remove('is-loading');
        atcBtn.classList.remove('is-success');
        if (textContainer) {
          textContainer.innerHTML = originalHtml;
        }
        alert('ไม่สามารถหยิบสินค้าลงในตะกร้าได้ กรุณาลองใหม่อีกครั้ง');
      });
    });

    // 2. Mobile Tap-to-Active Handler
    const isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
    if (isTouch) {
      document.addEventListener('click', function(e) {
        const card = e.target.closest('.icc-product-card');
        
        // Deactivate all cards if clicking outside
        if (!card) {
          document.querySelectorAll('.icc-product-card.is-active').forEach(el => el.classList.remove('is-active'));
          return;
        }

        // If clicked on an action button, qty button, or link directly, let it proceed
        if (e.target.closest('.js-icc-atc-btn') || e.target.closest('.js-icc-qty-btn') || e.target.closest('.icc-quantity-wrapper') || e.target.closest('a')) {
          return;
        }

        // Toggle active state for this card
        const wasActive = card.classList.contains('is-active');
        document.querySelectorAll('.icc-product-card.is-active').forEach(el => el.classList.remove('is-active'));
        if (!wasActive) {
          card.classList.add('is-active');
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomProductCards);
  } else {
    initCustomProductCards();
  }
})();
